import { PhoneNumberType } from '../../features/phone-number/thunks/phone-number.thunk'

/**
 * Phone number service
 * All API requests pertaining to working with global phone numbers
 */

export class PhoneNumberService {
  /**
   * Get all phone numbers method
   * Fetches MTN MoMo supported countries from local JSON file
   * @returns Promise<any>
   */
  public async getAllPhoneNumbers() {
    const response = await fetch('/countries.json')
    const data = await response.json()
    return { data }
  }
}

/**
 * For future reference
 */

// export const fetchData = async () => {
//   const source = 'https://restcountries.com/v2/all'
//   const response = await fetch(source)
//   let data = await response.json()
//   data = data.map(
//     (country: {
//       name: string
//       callingCodes: string[]
//       flags: {
//         png: string
//       }
//     }) => {
//       return { name: country.name, callingCode: country.callingCodes[0], flag: country.flags.png }
//     },
//   )

//   return data
// }
